import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import type { MessageKey } from './types'

export type TranslateValues = Record<string, string | number>

export function useT() {
  const intl = useIntl()
  return useCallback(
    (key: MessageKey, values?: TranslateValues) => intl.formatMessage({ id: key }, values),
    [intl],
  )
}
